module.exports = __webpack_public_path__ + "img/contact-icon.4cd7aa39.png";